export default async function postComponents(body) {
  const endpoint = localStorage.getItem("api");

  const url = endpoint + "component";
  const js = JSON.stringify(body);

  const header = {
    "Content-Type": " application/json",
  };

  try {
    const config = { method: "POST", headers: header, body: js };
    const response = await fetch(url, config);
    const json = await response.json();

    if (json.status === true) {
      return json;
    } else {
      return {
        data: [],
      };
    }
  } catch (error) {
    console.log("Error" + error);
  }
}
